<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listTypesOfPaymentReceipts"
        :title-table="$t('Types Of Payment Receipt')"
        module="typeOfPaymentReceiptSettingsModule"
        sort-name="descricao"
        add-permission="ROLE_TIPO_PAGAMENTO_RECEBIMENTO_INSERIR"
        view-permission="ROLE_TIPO_PAGAMENTO_RECEBIMENTO_CONSULTAR"
        edit-permission="ROLE_TIPO_PAGAMENTO_RECEBIMENTO_ATUALIZAR"
        delete-permission="ROLE_TIPO_PAGAMENTO_RECEBIMENTO_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <FormTypeOfPaymentReceipt v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";
import FormTypeOfPaymentReceipt from "./forms/FormTypeOfPaymentReceipt.vue";

export default {
  name: "TypeOfPaymentReceipt",
  components: {
    BRow,
    BCol,
    TableComponents,
    FormTypeOfPaymentReceipt,
  },
  computed: {
    ...mapState("typeOfPaymentReceiptSettingsModule", {
      listTypesOfPaymentReceipts: (state) => state.listTypesOfPaymentReceipts,
    }),
  },
  // mixins: [mixinsGlobal],
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: this.$t("id"),
          field: "id",
        },
        {
          label: "Descrição",
          field: "descricao",
        },
        {
          label: "Plano de Conta",
          field: "planoDeConta.classe",
        },
        {
          label: this.$t("Action"),
          field: "action",
        },
      ],
    };
  },
  methods: {
    addNew() {
      this.$store.dispatch(
        "typeOfPaymentReceiptSettingsModule/resetTypeOfPaymentReceipt",
      );
      this.showForm = true;
    },
    edit(data) {
      this.$store.dispatch(
        "typeOfPaymentReceiptSettingsModule/prepareToEditTypeOfPaymentReceipt",
        data,
      );
      this.showForm = true;
    },
    cancelar() {
      this.showForm = false;
    },
  },
};
</script>
